interface TopicDatesProps {
    data: any | null;
  open?: any | null;
    daysDifference: any | null;
    earliestStartDate: any | null;
}

const TopicDates: React.FC<TopicDatesProps> = ({ data, daysDifference, earliestStartDate }) => {

  const start = new Date(data.date_start);
  const end = new Date(data.date_end);
  const earliest = new Date(earliestStartDate);

  const margLeft = Math.ceil((start.getTime() - earliest.getTime()) / (1000 * 60 * 60 * 24));

  // Calculate the difference in days
  const width = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
  const graphWidth = daysDifference;

  // Calculate the percentage width
  const percentageWidth = (width / graphWidth) * 100;
  const percentageLeft=(margLeft / graphWidth) * 100;


  // You might want to ensure the percentage is not greater than 100%
  const safePercentageWidth = Math.min(percentageWidth, 100);
  const safePercentageLeft = Math.min(percentageLeft, 100);

  return (
    <div className={`text-[14px] leading-[16px] pr-[60px] py-0 pl-[16px] rounded-[25px] mt-[0] mx-[0] mb-[4px] h-[50px] relative flex items-center topic-dates-${data.colour} ${data.background} ${data.text}`} 
          style={{marginLeft: `${safePercentageLeft}%`, width: `${safePercentageWidth}%`}}>
        {width > 100 ? data.heading 
        : <span className="outside-label" style={{left: margLeft === 0 ? 'auto' : '-150px', right: margLeft === 0 ? '-150px' : 'auto', textAlign: margLeft === 0 ? 'left' : 'right' }}>{data.heading}</span>} 
        <span className={`rounded-[25px] h-[50px] w-[50px] top-[0] absolute right-[0] z-10 ${data.dot}`}></span>
    </div>
  )

}

export default TopicDates;


